<template>
    <div>
        <vue-html2pdf :show-layout="false" :float-layout="true" :enable-download="true" :preview-modal="false"
            :paginate-elements-by-height="1400" :pdf-quality="2" :manual-pagination="true" pdf-format="a4"
            pdf-orientation="landscape" pdf-content-width="750px" :html-to-pdf-options="htmlToPdfOptions" ref="html2Pdf"
            :key="componentKey + 'a'">
            <section slot="pdf-content" style="display: flex; flex-direction: column; height: 100%;">
                <vs-row style="background: white;">
                    <vs-col w="6" class="d-flex">
                        <div class="d-flex">
                            <div class="opcionPrincipalPDF">
                                <p class="mb-0 mr-1 pdfLetra"><small><strong>INSTITUCION:</strong></small></p>
                            </div>
                            <div v-for="cole in filtros.instituciones" :key="cole.id">
                                <p v-if="cole.id == filtros.institucion" class="mb-0 pdfLetra" style="padding: 3px 5px;">
                                    <strong>{{ cole.text }}</strong>
                                </p>
                            </div>
                        </div>
                    </vs-col>
                    <vs-col w="6" class="d-flex">
                        <div class="d-flex">
                            <div class="opcionPrincipalPDF">
                                <p class="mb-0 mr-1 pdfLetra"><small><strong>CICLO:</strong></small></p>
                            </div>
                            <div v-for="ciclo in filtros.ciclosEscolares" :key="ciclo.id">
                                <p v-if="ciclo.id == filtros.cicloEscolar" class="mb-0 pdfLetra" style="padding: 3px 5px;">
                                    <strong>{{ ciclo.text }}</strong>
                                </p>
                            </div>
                        </div>
                    </vs-col>
                </vs-row>
                <vs-row>
                    <vs-col sm="12" lg="3" v-for="(foto, i) in imagenes" :key="i" class="p-2">
                        <div class="mb-3">
                            <form>
                                <div class="image-upload text-center">
                                    <label class="objetfitcover">
                                        <img :src="'/api/personas/' + foto.persona_id + '/avatar'" />
                                    </label>
                                </div>
                            </form>
                        </div>
                        <div class="text-center">
                            <h6 class="mb-0">{{ foto.nombre }}</h6>
                            <p class="mb-0"><small>MATRÍCULA</small></p>
                            <p class="mb-0"><strong>{{ foto.matricula }}</strong></p>
                        </div>
                    </vs-col>
                </vs-row>
            </section>
        </vue-html2pdf>
        <vs-row :key="componentKey">
            <vs-col w="12" v-if="JSON.parse(personaRol).roles[0].id == 1 && imagenes[0]">
                <vs-button class="ml-auto" @click="openLoading()">
                    Descargar PDF
                </vs-button>

            </vs-col>
            <vs-col w="12" v-if="imagenes.length">
                <vs-button warn class="ml-auto" :disabled="!selected.length" @click="postBorrarFotografias()">
                    Borrar fotografías
                </vs-button>
            </vs-col>
            <vs-col w="12" class="mt-3" v-if="imagenes.length">
                <vs-checkbox :indeterminate="selected.length == imagenes.length" v-model="allCheck"
                    @change="selected = $vs.checkAll(selected, imagenes)">
                    <span v-if="!selected.length">Seleccionar </span>
                    <span v-else>Deseleccionar </span> todo
                </vs-checkbox>
                <hr>
            </vs-col>
            <vs-col sm="12" lg="3" v-for="(foto, index) in imagenes" :key="index" :data="foto" class="p-3 borderFoto">
                <div class="mb-3">
                    <vs-checkbox :val="foto" v-model="selected" />
                </div>
                <div class="mb-3">
                    <form>
                        <div class="image-upload text-center">
                            <label :for="'file-input' + index" class="objetfitcover">
                                <img v-if="foto.avatar == '/img/default-avatar.jpg'" src="/img/default-avatar.jpg" />
                                <img v-else :src="foto.avatar" />
                            </label>
                            <input :id="'file-input' + index" type="file" ref="foto" accept=".jpg,.jpeg,.png"
                                @input="select(index, foto.persona_id)" />
                        </div>
                    </form>
                </div>
                <div class="text-center">
                    <h6 class="mb-0">{{ foto.nombre }}</h6>
                    <p class="mb-0"><small>MATRÍCULA</small></p>
                    <p class="mb-0"><strong>{{ foto.matricula }}</strong></p>
                </div>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import Axios from 'axios';
import VueHtml2pdf from 'vue-html2pdf'
import servicios from '../../../../api/requests/servicios.js'
export default {
    props: [
        'imagenes',
        'abrirModal',
        'personaRol',
        'filtros'
    ],
    data() {
        return {
            componentKey: 0,
            isLog: true,
            filelist: [],
            active: false,
            selected: [],
            allCheck: false
        }
    },
    computed: {
        htmlToPdfOptions() {
            if (this.users != '') {
                return {
                    filename: 'Fotografías',
                    margin: [5, 5, 5, 5],
                    image: {
                        type: "png",
                        quality: 1
                    },
                    html2canvas: { useCORS: true },
                    pagebreak: { mode: 'avoid-all', after: '.avoidThisRow' }
                };
            }
        },
        filteredItems: function () {
            return this.users.alumnos.slice(0, 10)
        }
    },
    components: {
        VueHtml2pdf
    },
    methods: {
        openLoading() {
            const loading = this.$vs.loading({
                target: this.$refs.html2Pdf.generatePdf(),
            })
            setTimeout(() => {
                loading.close()
            }, 15000)
        },
        forceRefresh() {
            this.componentKey += 1;
        },
        select(index, idPersona) {
            let loading = this.$vs.loading()
            const formData = new FormData();
            formData.append('avatar', this.$refs.foto[index].files[0])

            axios.post('/api/personas/' + idPersona + '/avatar', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(res => {
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Operación éxitosa.',
                    text: 'Se ha actualizado con éxito la fotografía.'
                })
                this.forceRefresh()
                this.$emit('refreshComponent')
            }).catch(e => {
                loading.close()
                console.log('error', e);
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Error.',
                    text: 'Error al carga.'
                })
            });
        },
        async postBorrarFotografias() {
            const loading = this.$vs.loading()
            try {
                const ids = this.selected.map(s => s.persona_id)
                console.log('ids', ids)
                const persons_ids = {
                    persons_ids: ids
                }
                console.log('persons_ids', persons_ids)
                const response = await servicios.postBorrarFotografias(persons_ids)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: 'bottom-right',
                    title: 'Operación éxitosa',
                    text: 'Se han eliminado las fotografías seleccionadas'
                })
                this.$emit('refreshComponent')
                loading.close()
            } catch (error) {
                console.log(error)
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: 'bottom-right',
                    title: 'Hubo un error',
                    text: 'Favor de contactar al administrador'
                })
                this.$emit('refreshComponent')
            }
        },
    },
    watch: {
        abrirModal() {
            this.active = this.abrirModal
        },
        value(val) {
            this.active = val
        },
        async active(val) {
            if (!val) {
                this.$emit('input', val);
            }
        },
        imagenes() {
            this.forceRefresh()
        }
    }
}
</script>

<style scoped>
.image-upload>input {
    display: none;
}

.objetfitcover>img {
    width: 150px;
    height: 150px;
    object-fit: cover;
}

[v-cloak] {
    display: none;
}

.borderFoto {
    border: 1 solid gray;
    border-radius: 5px;
}
</style>
